
import Vue from 'vue'
import { BLogoV } from '@/components/svg'

export default Vue.extend({
  components: { BLogoV },
  props: {
    loading: Boolean
  },
  data() {
    return {
      timeout: 0,
      show: false
    }
  },
  mounted() {
    const img = new Image()
    img.onload = () => {
      this.show = true
      this.timeout = window.setTimeout(() => {
        this.$emit('close')
      }, 3000)
    }
    img.onerror = () => {
      console.error('Failed to load the loading image')
      this.$emit('close')
    }
    img.src = 'https://static.bobuafrica.com/loading.webp'

    document.body.style.overflow = 'hidden'
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
    document.body.style.overflow = ''
  }
})
